export const  style = {
      
    minWidth: '300px',
    minHeight: '55px',
    border: '3px solid #16f9b2',
    padding: '16px',
    color: '#000',
    background: '#16f9b2',
    zIndex:"99999"
    
}

export const iconTheme = {
    primary: '#000',
    secondary: '#fff',
}

export const  position= {
    position: "top-center"
}


export const  zindex= {
    zIndex: "99999"
}